import { i as w, f as j } from "./es.object.to-string-f55666a8.js";
import { F as $, E as x, D as R, b as F, i as L, t as E, N } from "./export-cdcbfb2b.js";
var D = $, M = Array.isArray || function(r) {
  return D(r) === "Array";
}, y = M, g = w, k = R, K = x, B = K("species"), S = Array, H = function(a) {
  var r;
  return y(a) && (r = a.constructor, g(r) && (r === S || y(r.prototype)) ? r = void 0 : k(r) && (r = r[B], r === null && (r = void 0))), r === void 0 ? S : r;
}, J = H, U = function(a, r) {
  return new (J(a))(r === 0 ? 0 : r);
}, V = j, X = F, q = L, z = E, G = N, Q = U, I = X([].push), e = function(a) {
  var r = a === 1, p = a === 2, b = a === 3, v = a === 4, u = a === 6, O = a === 7, A = a === 5 || u;
  return function(i, C, _, h) {
    for (var f = z(i), c = q(f), d = G(c), m = V(C, _), n = 0, l = h || Q, s = r ? l(i, d) : p || O ? l(i, 0) : void 0, t, o; d > n; n++)
      if ((A || n in c) && (t = c[n], o = m(t, n, f), a))
        if (r)
          s[n] = o;
        else if (o)
          switch (a) {
            case 3:
              return !0;
            case 5:
              return t;
            case 6:
              return n;
            case 2:
              I(s, t);
          }
        else
          switch (a) {
            case 4:
              return !1;
            case 7:
              I(s, t);
          }
    return u ? -1 : b || v ? v : s;
  };
}, T = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: e(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: e(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: e(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: e(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: e(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: e(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: e(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: e(7)
};
export {
  T as a,
  U as b,
  M as i
};
